/**
 * Fashion Modal Component - Newsletter Popup
 * Handles modal display with cookie-based persistence
 */
export default function fashionModal() {
  return {
    isOpen: false,
    delay: 5000,

    init() {
      // Check if modal has been shown before
      if (this.hasSeenModal()) {
        return;
      }

      // Get delay from data attribute
      const modalElement = document.getElementById('fashion-modal');
      if (modalElement) {
        this.delay = parseInt(modalElement.dataset.popupDelay) || 5000;
      }

      // Show modal after delay
      setTimeout(() => {
        this.open();
      }, this.delay);
    },

    open() {
      this.isOpen = true;
      const modalElement = document.getElementById('fashion-modal');
      if (modalElement) {
        modalElement.classList.remove('hidden');
        modalElement.classList.add('flex');
      }
      document.body.style.overflow = 'hidden';
    },

    close() {
      this.isOpen = false;
      const modalElement = document.getElementById('fashion-modal');
      if (modalElement) {
        modalElement.classList.add('hidden');
        modalElement.classList.remove('flex');
      }
      document.body.style.overflow = '';

      // Set cookie to remember modal was closed
      this.setModalCookie();
    },

    hasSeenModal() {
      // Check if cookie exists
      const cookies = document.cookie.split(';');
      for (const cookie of cookies) {
        const [name] = cookie.trim().split('=');
        if (name === 'fashion_modal_seen') {
          return true;
        }
      }
      return false;
    },

    setModalCookie() {
      // Set cookie for 30 days
      const expiryDate = new Date();
      expiryDate.setDate(expiryDate.getDate() + 30);
      document.cookie = `fashion_modal_seen=1; expires=${expiryDate.toUTCString()}; path=/`;
    },

    handleOutsideClick(event) {
      // Close modal if clicking outside the content
      if (event.target.id === 'fashion-modal') {
        this.close();
      }
    },

    handleEscape(event) {
      // Close modal on Escape key
      if (event.key === 'Escape' && this.isOpen) {
        this.close();
      }
    },
  };
}
